import { render, staticRenderFns } from "./GameCardStack.vue?vue&type=template&id=321083f0&scoped=true&"
import script from "./GameCardStack.vue?vue&type=script&lang=js&"
export * from "./GameCardStack.vue?vue&type=script&lang=js&"
import style0 from "./GameCardStack.vue?vue&type=style&index=0&id=321083f0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321083f0",
  null
  
)

export default component.exports